import Link from 'next/link';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import i18n from 'src/utils/translate';

type Props = {
  tags: { name: string }[];
  username: string;
}
export default function MemberTags({ tags, username }: Props) {
  const filteredTags = tags.reduce((acc, current) => { // remove duplicates
    if (!acc.find((term) => term.name === current.name)) acc.push(current);
    return acc;
  }, []);

  const handleTagClick = () => {
    trackFootfallEvent(Event.CLICKED, {
      clickType: 'member-card',
      clickMetadata: { section: Section.CommunityMembers, element: Element.MemberTag },
    });
  };

  const as = `/user/${username}`;
  const href = `/user/profile?username=${username}`;

  return (
    <ul className="button-tags member-tags">
      {filteredTags.map(({ name }) => (
        <li key={name}>
          <Link
            as={as}
            className="button-tag"
            href={href}
            onClick={handleTagClick}
          >
            {name}
          </Link>
        </li>
      ))}
      <li>
        <Link
          as={as}
          className="see-more"
          href={href}
          onClick={handleTagClick}
        >
          {i18n.t('See more')}
        </Link>
      </li>
    </ul>
  );
}
